module.exports = __webpack_public_path__ + "static/media/oasis2.fa81a776.png";